<template>
  <div class="map-cnt">
    <div class="ty-banner-1">
      <img
        alt="河南万杰智能科技股份"
        src="@img/subpage-banner.jpg"
        title="河南万杰智能科技股份"
      />
    </div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <!-- <b>您的位置:</b> -->
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/map">网站地图</router-link>
        </div>
      </div>
      <div class="clear"></div>
      <div class="map-site">
        <!-- 11 -->
        <div class="lead">
          <router-link to="/">首页</router-link>
        </div>
        <ul class="sub-site">
          <li>
            <router-link to="/products/all">产品展示</router-link>
          </li>
          <li>
            <router-link to="/case">成功案例</router-link>
          </li>
          <li>
            <router-link to="/news/all">新闻动态</router-link>
          </li>
          <li>
            <router-link to="/about/problem">常见问题</router-link>
          </li>
          <li>
            <router-link to="/about">关于我们</router-link>
          </li>
        </ul>
        <!-- 22 -->
        <div class="lead">
          <router-link to="/products/all">产品展示</router-link>
        </div>
        <ul class="sub-site">
          <li v-for="(item, index) in productTypes" :key="index">
            <router-link :to="item.name | toPy('/products/')">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
        <!-- 33 -->
        <div class="lead">
          <router-link to="/case">成功案例</router-link>
        </div>
        <ul class="sub-site">
          <li v-for="(item, index) in aboutList" :key="index">
            <router-link :to="'/case/' + item.path">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
        <!-- 44 -->
        <div class="lead">
          <router-link to="/about">关于万杰</router-link>
        </div>
        <ul class="sub-site">
          <li v-for="(item, index) in aboutList" :key="index">
            <router-link :to="'/about/' + item.path">
              {{ item.name }}
            </router-link>
          </li>
        </ul>
        <!-- 55 -->
        <div class="lead">
          <router-link to="/news/all">新闻动态</router-link>
        </div>
        <ul class="sub-site">
          <li>
            <router-link to="/news/gsxw">公司新闻</router-link>
          </li>
          <li>
            <router-link to="/news/xydt">行业动态</router-link>
          </li>
          <li>
            <router-link to="/news/sbczsp">设备操作视频</router-link>
          </li>
        </ul>
        <!-- 66 -->
        <div class="lead">
          <router-link to="/">其他</router-link>
        </div>
        <ul class="sub-site">
          <li>
            <a
              href="https://wanjiepai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.456a689aKx0Vgm"
              target="_blank"
            >
              天猫店铺
            </a>
          </li>
          <li>
            <a
              href="https://wanjiepai.tmall.com/index.htm?spm=a1z10.1-b.w5002-21892435601.2.392d4b19u5rBHF"
              target="_blank"
            >
              淘宝店铺
            </a>
          </li>
          <li>
            <a
              href="https://wanjiezhineng.1688.com/?spm=a261y.7663282.autotrace-common_topbar.1.7e203851QuVc3O"
              target="_blank"
            >
              阿里店铺
            </a>
          </li>
          <li>
            <a
              href="https://mall.jd.com/index-791402.html?from=pc"
              target="_blank"
            >
              京东店铺
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import searchBar from "./common/searchBar.vue";
import utils from "@/api/to_py.js";
export default {
  data() {
    return {
      productTypes: [],
      caseList: [],
      aboutList: []
    };
  },
  components: {
    searchBar
  },
  watch: {
    "$route.query"() {
      // '$route.query' 这个函数是关键
      // console.log(this.$route)
      this.searchText = this.$route.query.q;
      // Object.assign(this.$data, this.$options.data()); // 将跳转前的数据置空
      this.product_info_list(); // 再初始化当前的页面
    }
  },
  mounted: function() {
    this.getRroductType();
    console.log(this.$router.options.routes);
    const array = this.$router.options.routes;
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      if (element.name == "case") {
        this.caseList = element.children;
      } else if (element.name == "about") {
        this.aboutList = element.children;
      }
    }
  },
  methods: {
    getRroductType: function() {
      this.$post("/Product/product_class_list", {}).then(response => {
        this.productTypes = response.data || [];
        // this.product_info_list();
      });
    }
  },
  filters: {
    findpy(id, arrs, idd) {
      var baseurl = "/product/";
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + "/" + idd + ".html";
          return;
        }
      });
      return baseurl;
    },
    toPy(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    },
    compare(parm, type, id) {
      return parm == type ? "nav-active" : "";
    }
  }
};
</script>

<style lang="less">
@import "~@css/warp.less";
.map-cnt {
  // background: rgba(247, 247, 247, 1);
  background: #ffffff;
  padding-bottom: 200px;
  .map-site {
    // background: #fff;
    .lead {
      padding: 10px 10px 6px 10px;
      // background: #efefef;
      background: #efefef;
      line-height: 19px;
      margin-top: 20px;
      font-size: 20px;
      font-weight: bold;
      &::before {
        width: 8px;
        height: 20px;
        content: "";
        margin: 0 15px 4px 0;
        background: #13b5b3;
        display: inline-block;
        vertical-align: middle;
      }
      a {
        color: #13b5b3;
      }
    }
    .sub-site {
      padding: 20px 0;
      font-size: 14px;
      line-height: 20px;
      li {
        padding: 6px 0;
        display: inline-block;
        width: 15%;
        a {
          display: block;
        }
        a:hover {
          color: #13b5b3;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue